import apiClient from './apiClient';

export const getBillingPlans = () => apiClient('/billing/plans');
export const getBillingAccount = () => apiClient('/billing/me');
export const beginMockCheckout = (planCode, clientRequestId, provider = null, phone = null) =>
  apiClient('/billing/checkout', {
    method: 'POST',
    body: JSON.stringify({ planCode, clientRequestId, provider, phone }),
  });
export const settleMockPayment = (paymentId, outcome) =>
  apiClient(`/billing/mock-payments/${paymentId}/settle`, {
    method: 'POST',
    body: JSON.stringify({ outcome }),
  });
export const simulateMockExpiration = () =>
  apiClient('/billing/mock-expire', { method: 'POST' });

export const cancelMobileMoneyPayment = (id) => apiClient(`/billing/mobile-money/${encodeURIComponent(id)}/cancel`, {method: 'POST'});
